import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { RouterLink } from "@irati/ui/src/Link";
import { doIHavePermission } from "@irati/utils/permissions/HasPermissionTo";
import authentication from "@irati/auth";
var idNamespace = "secondaryNav";
var MedicalSecondaryNavLinks = function (_a) {
    var pathname = _a.pathname;
    var hasAdminAccess = authentication.hasAdminAccess();
    var hasPermission = doIHavePermission(["medical"], authentication.apps());
    if (!hasAdminAccess || !hasPermission)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(RouterLink, { id: id("link-my-medical", idNamespace), to: "/my-medical", className: pathname.includes("/my-medical") && "active" },
            React.createElement(FormattedMessage, { id: "medical.navigation.myMedical" })),
        React.createElement(RouterLink, { id: id("link-medical-reports", idNamespace), to: "/reports", className: pathname.includes("/reports") && "active" },
            React.createElement(FormattedMessage, { id: "medical.navigation.reports" }))));
};
export default MedicalSecondaryNavLinks;
